var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFinance = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Accounting-Coins--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Accounting Coins Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.67 9.21A0.23 0.23 0 0 0 7.42 9 7.5 7.5 0 1 0 15 16.57a0.23 0.23 0 0 0 -0.2 -0.24 9 9 0 0 1 -7.13 -7.12Zm1.73 5a0.75 0.75 0 0 1 -0.75 0.75h-1.9a0.51 0.51 0 0 0 -0.5 0.51 0.48 0.48 0 0 0 0.32 0.46l1.92 0.77a2 2 0 0 1 -0.3 3.8 0.26 0.26 0 0 0 -0.19 0.25V21a0.75 0.75 0 0 1 -1.5 0v-0.17a0.25 0.25 0 0 0 -0.25 -0.25h-0.4a0.75 0.75 0 0 1 0 -1.5h1.9a0.5 0.5 0 0 0 0.5 -0.5 0.48 0.48 0 0 0 -0.31 -0.46L6 17.34a2 2 0 0 1 -1.26 -1.85 2 2 0 0 1 1.56 -2 0.24 0.24 0 0 0 0.19 -0.24v-0.23a0.75 0.75 0 0 1 1.5 0v0.16a0.25 0.25 0 0 0 0.25 0.25h0.4a0.76 0.76 0 0 1 0.76 0.8Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0A7.5 7.5 0 1 0 24 7.5 7.5 7.5 0 0 0 16.5 0Zm0 13.21a0.76 0.76 0 0 1 -0.75 -0.75V12a0.25 0.25 0 0 0 -0.25 -0.25h-0.75a0.75 0.75 0 0 1 0 -1.5h2.37a0.82 0.82 0 0 0 0.82 -0.82 0.8 0.8 0 0 0 -0.52 -0.75l-2.4 -1a2.29 2.29 0 0 1 -1.46 -2.14 2.32 2.32 0 0 1 2 -2.29 0.24 0.24 0 0 0 0.19 -0.25v-0.5a0.75 0.75 0 1 1 1.5 0V3a0.25 0.25 0 0 0 0.25 0.25h0.75a0.75 0.75 0 0 1 0 1.5h-2.37a0.82 0.82 0 0 0 -0.82 0.82 0.8 0.8 0 0 0 0.52 0.75l2.4 1a2.29 2.29 0 0 1 1.46 2.14 2.32 2.32 0 0 1 -2 2.29 0.24 0.24 0 0 0 -0.21 0.24v0.5a0.76 0.76 0 0 1 -0.73 0.72Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFinance);
export default ForwardRef;